import { FormattedMessage } from 'react-intl';

import { Button } from '@xing-com/button';
import { GridItem } from '@xing-com/grid';
import { Headline } from '@xing-com/typography';

import { Styled } from './register-banner.styles';

type RegisterBannerProps = {
  topicKey?: string;
};

export const RegisterBanner: React.FC<RegisterBannerProps> = ({ topicKey }) => {
  const trackingKey = `/start/signup?sc_o=career_hub_application_sign_up_button_click&sc_o_PropActionOrigin=career_hub_application_${topicKey}_body
  signup_channel=careerhub`;

  return (
    <Styled.Banner>
      <Styled.HelloIllustration />
      <Styled.GridContainer variant="FullSize">
        <GridItem span={12}>
          <Headline size="xxlarge" as="strong">
            <FormattedMessage id="CAREER_HUB_REGISTER_BANNER_HEADER" />
          </Headline>
          <Styled.BodyCopy size="large">
            <FormattedMessage id="CAREER_HUB_REGISTER_BANNER_SUBLINE" />
          </Styled.BodyCopy>
        </GridItem>
      </Styled.GridContainer>
      <Button
        data-qa="career-hub-register-button"
        variant="primary"
        to={topicKey ? trackingKey : '/start/signup'}
        size="large"
      >
        <FormattedMessage id="CAREER_HUB_REGISTER_BANNER_BUTTON" />
      </Button>
    </Styled.Banner>
  );
};
